const slideAnimations = new WeakMap();

// direction: 'down' opens, 'up' closes
function slide(el, direction, duration = 400, onComplete) {
    const running = slideAnimations.get(el);

    if (running && running.playState === 'running') {
        // Animation in flight. playbackRate > 0 means it's heading "down" (opening).
        const headingDown = running.playbackRate > 0;
        const wantDown = direction === 'down';

        if (headingDown !== wantDown) {
            running.onComplete = onComplete; // take over the callback
            running.reverse();
        }
        // Already heading the right way → let it finish, nothing to do
        return;
    }

    const isHidden = getComputedStyle(el).display === 'none';

    // Already in the target state → just fire the callback
    if ((direction === 'down' && !isHidden) || (direction === 'up' && isHidden)) {
        if (typeof onComplete === 'function') onComplete(el);
        return;
    }

    if (isHidden) {
        el.style.display = 'block';
    }

    const height = el.scrollHeight;
    const style = getComputedStyle(el);

    // Keyframes always describe closed → open
    const animation = el.animate(
        [
            { height: '0px', paddingTop: '0px', paddingBottom: '0px', overflow: 'hidden' },
            {
                height: height + 'px',
                paddingTop: style.paddingTop,
                paddingBottom: style.paddingBottom,
                overflow: 'hidden',
                zIndex: 1,
            },
        ],
        { duration, easing: 'ease-in-out' },
    );

    if (direction === 'up') {
        animation.reverse(); // play closed ← open
    }

    animation.onComplete = onComplete;

    animation.onfinish = () => {
        if (animation.playbackRate < 0) {
            el.style.display = 'none';
        }
        slideAnimations.delete(el);
        const cb = animation.onComplete;
        if (typeof cb === 'function') cb(el);
    };

    slideAnimations.set(el, animation);
}

export function slideDown(el, duration = 400, onComplete) {
    slide(el, 'down', duration, onComplete);
}

export function slideUp(el, duration = 400, onComplete) {
    slide(el, 'up', duration, onComplete);
}

export function slideToggle(el, duration = 400, onComplete) {
    const running = slideAnimations.get(el);

    if (running && running.playState === 'running') {
        running.onComplete = onComplete;
        running.reverse();
        return;
    }

    const isHidden = getComputedStyle(el).display === 'none';
    slide(el, isHidden ? 'down' : 'up', duration, onComplete);
}
